function cov_lce3fc9jr() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Reset.tsx";
  var hash = "0e7c33857cf4064ea7f6cca141e96f1d352a196b";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Reset.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 45
        },
        end: {
          line: 5,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "0e7c33857cf4064ea7f6cca141e96f1d352a196b"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_lce3fc9jr = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_lce3fc9jr();
var Icon = (cov_lce3fc9jr().s[0]++, {
  name: 'reset',
  svg: "<path d=\"M7.93876 1.29655C8.33934 0.901148 8.98687 0.901148 9.38744 1.29655L11.3767 3.26019C11.7799 3.65819 11.7799 4.30545 11.3767 4.70345L9.38744 6.66708C8.98687 7.06249 8.33934 7.06249 7.93876 6.66708C7.53556 6.26909 7.53556 5.62182 7.93876 5.22383L8.16552 5H8C5.84387 5 4.05348 6.77404 4.05348 8.89091C4.05348 8.89091 4 10 3 10C2 10 2 8.89091 2 8.89091C2 5.64051 4.7187 2.96364 8 2.96364H8.16552L7.93876 2.73981C7.53556 2.34181 7.53556 1.69455 7.93876 1.29655Z\" fill=\"#1C85E8\"/>\n  <path d=\"M7.73995 14.7034C7.33937 15.0989 6.69184 15.0989 6.29127 14.7034L4.30197 12.7398C3.89877 12.3418 3.89877 11.6946 4.30197 11.2966L6.29127 9.33292C6.69184 8.93751 7.33937 8.93751 7.73995 9.33292C8.14315 9.73091 8.14315 10.3782 7.73995 10.7762L7.51319 11H7.67871C9.83484 11 11.6252 9.22596 11.6252 7.10909C11.6252 7.10909 11.6787 6 12.6787 6C13.6787 6 13.6787 7.10909 13.6787 7.10909C13.6787 10.3595 10.96 13.0364 7.67871 13.0364H7.51319L7.73995 13.2602C8.14315 13.6582 8.14315 14.3054 7.73995 14.7034Z\" fill=\"#1C85E8\"/>"
});
export default Icon;